import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  getCompanyListWithStartAndEnd,
  getCompanyList,
  savePaginationValues,
  resetQuickSelectedRow,
  saveAdvancedSelectedFilters,
} from "../../actionCreator/companyListingActionCreater";
import QuickSelection from "../../common/QuickSelection";

const CompanyNavigation = () => {
  const dispatch = useDispatch();
  const companySelectedFilterList = useSelector(
    (state) => state.companyListingReducer.selectedFilters,
  );
  const [selectedRange, setSelectedRange] = useState({
    start: "",
    end: "",
  });
  const topSearchValue = useSelector(
    (state) => state.HeaderReducer.topSearchValue,
  );
  const companySelectionList = useSelector(
    (state) => state.companyListingReducer?.companySelectionList,
  );
  const totalRecords = useSelector(
    (state) => state.companyListingReducer?.totalCount,
  );

  useEffect(() => {
    if (companySelectionList && companySelectionList?.length === 0) {
      setSelectedRange({
        start: "",
        end: "",
      });
    }
  }, [companySelectionList]);

  useEffect(() => {
    if (companySelectedFilterList?.quickSelectionRange?.start) {
      setSelectedRange(companySelectedFilterList?.quickSelectionRange);
      onClickQuickSelection(companySelectedFilterList?.quickSelectionRange);
    } else {
      onClearQuickSelection();
    }
  }, [
    companySelectedFilterList?.pageSize,
    companySelectedFilterList?.quickSelectionRange?.start,
  ]);
  const onChangeSelectedRange = (e) => {
    setSelectedRange({
      ...selectedRange,
      [e.target.name]: e.target.value,
    });
  };

  const onClearQuickSelection = () => {
    setSelectedRange({
      start: "",
      end: "",
    });
    dispatch(resetQuickSelectedRow([]));
    dispatch(
      saveAdvancedSelectedFilters({
        ...companySelectedFilterList,
        quickSelectionRange: null,
      }),
    );
  };

  const onClickQuickSelection = (range) => {
    let errCnt = 0;
    const pageValues1 = {
      start: range ? range?.start : selectedRange?.start,
      end: range ? range.end : selectedRange.end,
    };

    const pageValues = {
      start:
        pageValues1?.start && pageValues1?.start > 0
          ? pageValues1.start - 1
          : 0,
      end: companySelectedFilterList?.pageSize || 10,
    };
    let payload = {
      ...companySelectedFilterList,
      quickSelectionRange: range ? range : selectedRange,
    };

    if (topSearchValue) {
      payload = {
        ...payload,
        topSearchValue: topSearchValue,
      };
    }

    dispatch(saveAdvancedSelectedFilters(payload));
    dispatch(savePaginationValues(pageValues));
    let searchPayload = {};
    if (Object.keys(companySelectedFilterList?.selectedSavedSearch).length) {
      searchPayload = JSON.parse(
        companySelectedFilterList?.selectedSavedSearch[0]?.dataDump,
      );
      if (errCnt === 0) {
        dispatch(getCompanyList(searchPayload, pageValues));
      }
      if (
        (pageValues1?.start || pageValues1?.start === 0) &&
        pageValues1?.end &&
        errCnt === 0
      ) {
        dispatch(
          getCompanyListWithStartAndEnd(searchPayload, {
            start: pageValues1.start - 1,
            end: pageValues1.end - 1,
            size: companySelectedFilterList?.pageSize || 10,
          }),
        );
      } else {
        dispatch(resetQuickSelectedRow([]));
        dispatch(
          saveAdvancedSelectedFilters({
            ...companySelectedFilterList,
            quickSelectionRange: null,
          }),
        );
      }
    } else {
      if (errCnt === 0) {
        dispatch(getCompanyList(payload, pageValues));
      }
      if (
        (pageValues1?.start || pageValues1?.start === 0) &&
        pageValues1?.end &&
        errCnt === 0
      ) {
        dispatch(
          getCompanyListWithStartAndEnd(payload, {
            start: pageValues1.start - 1,
            end: pageValues1.end - 1,
            size: companySelectedFilterList?.pageSize || 10,
          }),
        );
      } else {
        //dispatch to reset checkbox values
        dispatch(resetQuickSelectedRow([]));
        dispatch(
          saveAdvancedSelectedFilters({
            ...companySelectedFilterList,
            quickSelectionRange: null,
          }),
        );
      }
    }
  };

  return (
    <QuickSelection
      selectedRange={selectedRange}
      onChangeSelectedRange={onChangeSelectedRange}
      onClickQuickSelection={onClickQuickSelection}
      onClearQuickSelection={onClearQuickSelection}
      isClearVisible={!!companySelectedFilterList?.quickSelectionRange?.start}
      totalRecord={totalRecords}
    />
  );
};

export default CompanyNavigation;
